// src/components/DashboardLayout.jsx
import React from "react";
import { Outlet, useNavigate } from "react-router-dom";
import HeaderPremium from "./HeaderPremium";
import FooterPremium from "./FooterPremium";
import { useAuth } from "../context/AuthContext";

export default function DashboardLayout() {
  const navigate = useNavigate();
  const { logout } = useAuth();

  const handleLogout = async () => {
    await logout();
    navigate("/", { replace: true });
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        backgroundColor: "var(--page-bg)",
      }}
    >
      <HeaderPremium onLogout={handleLogout} />

      <main style={{ flex: 1 }}>
        <div className="zedro-page">
          <div className="container">
            <Outlet />
          </div>
        </div>
      </main>

      <FooterPremium variant="app" />
    </div>
  );
}
